import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { usersQueryKeys } from '@/modules/users/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface AssignTenantParams {
  userId: string;
  tenantId: string;
}

export const useAssignTenantMutation = () => {
  return useMutation({
    mutationFn: async ({ userId, tenantId }: AssignTenantParams) => {
      await fetchClient.POST(
        '/administration/users/{userId}/tenants/{tenantId}',
        {
          params: {
            path: {
              userId,
              tenantId,
            },
          },
        },
      );
    },
    onSettled: () => {
      invalidateQuery(usersQueryKeys.list())();
    },
  });
};
